import { Filter } from "./filter";

type WbsDataType = "list" | "task" | "milestone" | "event" | "doneElement";

type WbsFilter = Filter & {
  dataTypes?: WbsDataType[];
};

const wbsFilter: WbsFilter = {};

export type { WbsDataType, WbsFilter };

export { wbsFilter };
